
import { useProjectPath } from "./useProjectPath";


export const useProjectIdFromUrl = () => {
  const projectPath = useProjectPath();
  return projectPath?.params.projectId;
};
